<template>
    <span>
        <v-btn icon @click="showHelp">
            <v-icon :color="color" :title="title">help_outline</v-icon>
        </v-btn>
    </span>
</template>
<script>
export default {
    data() {
        return {
            //future update - save these links in the AppPages table as HelpLink field.
            //then pull everything on login
            helpLinks: [
                {
                    appId: 'attendance',
                    pages: [
                        {
                            pageId: 'myattendance',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html',
                            title: 'My Attendance User Guide'
                        },
                        {
                            pageId: 'mycalendar',
                            helpLink: 'https://help.sweldonow.ph/guide/common-pages.html#my-calendar',
                            title: 'My Calendar User Guide'
                        },
                        {
                            pageId: 'timeoff-daily',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#filing-time-off-using-my-attendance-daily-page',
                            title: 'Filing Time Off User Guide'
                        },
                        {
                            pageId: 'timeoff-page',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#filing-time-off-using-the-time-off-page',
                            title: 'Filing Time Off User Guide'
                        },
                        {
                            pageId: 'timeoff-review-team',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#reviewing-time-off',
                            title: 'Reviewing Timeoff User Guide'
                        },
                        {
                            pageId: 'timeoff-review-company',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#approving-rejecting-time-off-for-all-employees',
                            title: 'Reviewing Timeoff User Guide'
                        },
                        {
                            pageId: 'leave-balances',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#leave-balances',
                            title: 'Leave Balances User Guide'
                        },
                        {
                            pageId: 'overtime-daily',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#filing-overtime-using-my-attendance-daily-page',
                            title: 'Filing Overtime User Guide'
                        },
                        {
                            pageId: 'overtime-page',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#filing-overtime-using-the-overtime-page',
                            title: 'Filing Overtime User Guide'
                        },
                        {
                            pageId: 'overtime-review-team',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#approving-rejecting-overtime-for-team-members',
                            title: 'Reviewing Overtime User Guide'
                        },
                        {
                            pageId: 'overtime-review-company',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#approving-rejecting-overtime-for-all-employees',
                            title: 'Reviewing Overtime User Guide'
                        },
                        {
                            pageId: 'overtime-review',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#reviewing-overtime',
                            title: 'Reviewing Overtime User Guide'
                        },
                        {
                            pageId: 'timesheet-submission',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#timesheet-submission',
                            title: 'Timesheet Submission User Guide'
                        },
                        {
                            pageId: 'timesheet-review',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#reviewing-timesheet',
                            title: 'Reviewing Timesheet User Guide'
                        },
                        {
                            pageId: 'attendance-corrections',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#filing-of-attendance-corrections',
                            title: 'Attendance Corrections User Guide'
                        },
                        {
                            pageId: 'attendance-corrections-review-team',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#approving-rejecting-attendance-corrections-for-team-members',
                            title: 'Reviewing Attendance Corrections User Guide'
                        },
                        {
                            pageId: 'attendance-corrections-review-company',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#approving-rejecting-attendance-corrections-for-all-employees',
                            title: 'Reviewing Attendance Corrections User Guide'
                        },
                        {
                            pageId: 'team-attendance',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#team-attendance',
                            title: 'Team Attendance User Guide'
                        },
                        {
                            pageId: 'team-calendar',
                            helpLink: 'https://help.sweldonow.ph/guide/common-pages.html#team-calendar',
                            title: 'Team Calendar User Guide'
                        },
                        {
                            pageId: 'workshift-plan',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#workshift-plan-for-team-members',
                            title: 'Team Workshift Plan User Guide'
                        },
                    ]
                },
                {
                    appId: 'projects',
                    pages: [
                        {
                            pageId: 'projectcharges-daily',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#filing-project-charges-on-a-per-day-basis',
                            title: 'Add Project Task User Guide'
                        },
                        {
                            pageId: 'creating-project',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#creating-project',
                            title: 'Creating Projects User Guide'
                        },
                        {
                            pageId: 'creating-task',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#creating-task',
                            title: 'Creating Project Task User Guide'
                        },
                        {
                            pageId: 'project-charges-weekly',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#filing-project-charges-on-weekly-basis',
                            title: 'Project Charges User Guide'
                        },
                        {
                            pageId: 'project-charges-weekly-review',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#reviewing-project-charges',
                            title: 'Reviewing Project Charges User Guide'
                        },         
                        {
                            pageId: 'project-reports',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#project-reports',
                            title: 'Project Reports User Guide'
                        },
                        {
                            pageId: 'project-summary-report',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#project-summary-reports',
                            title: 'Project Summary Reports User Guide'
                        },
                        {
                            pageId: 'project-employee-report',
                            helpLink: 'https://help.sweldonow.ph/guide/projects.html#employee-task-charges-reports',
                            title: 'Project Employee Reports User Guide'
                        },
                    ]
                },
                {
                    appId: 'compensation',
                    pages: [
                        {
                            pageId: 'pay-grade',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#pay-grades',
                            title: 'Pay Grade User Guide'
                        },
                        {
                            pageId: 'compensation-benefits',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#compensation-and-benefits-2',
                            title: 'Compensation and Benefits User Guide'
                        },
                        {
                            pageId: 'add-salary',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#adding-basic-salary-and-pay-grade',
                            title: 'Adding Basic Salary and Pay Grade User Guide'
                        },
                        {
                            pageId: 'add-leaves',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#adding-leaves-allocation',
                            title: 'Adding Leaves Allocation User Guide'
                        },
                        {
                            pageId: 'add-deminimis',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#adding-deminimis-benefits',
                            title: 'Add Deminimis Benefits User Guide'
                        },
                        {
                            pageId: 'add-fringe-benefits',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#adding-fringe-benefits',
                            title: 'Adding Fringe Benefits User Guide'
                        },
                        {
                            pageId: 'add-other-benefits',
                            helpLink: 'https://help.sweldonow.ph/guide/compensation.html#adding-other-benefits',
                            title: 'Adding Other Benefits User Guide'
                        },
                    ]
                },
                {
                    appId: 'payroll',
                    pages: [
                        {
                            pageId: 'payroll-processing',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#payroll-processing',
                            title: 'Payroll Processing User Guide'
                        },
                        {
                            pageId: 'payroll-processing-individual',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#processing-payroll-individually',
                            title: 'Processing Payroll Individually User Guide'
                        },
                        {
                            pageId: 'payroll-processing-batch',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#processing-payroll-by-batch',
                            title: 'Processing Payroll Batch User Guide'
                        },
                        {
                            pageId: 'payroll-adustments',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#payroll-adjustments',
                            title: 'Payroll Adjustments User Guide'
                        },
                        {
                            pageId: 'payroll-adustments-create',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#creating-payroll-adjustments',
                            title: 'Creating Payroll Adjustments User Guide'
                        },
                        {
                            pageId: 'payroll-adustments-review',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#reviewing-payroll-adjustments',
                            title: 'Reviewing Payroll Adjustments User Guide'
                        },
                        {
                            pageId: 'annualization',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#annualization',
                            title: 'Annualization User Guide'
                        },
                        {
                            pageId: 'my-payslip',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#viewing-paylip-from-my-payslip-page',
                            title: 'My Payslip Guide'
                        },
                        {
                            pageId: 'sss-contributions',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#sss-contributions',
                            title: 'SSS Contributions Guide'
                        },
                        {
                            pageId: 'pagibig-contributions',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#pagibig-contributions',
                            title: 'Pagibig Contributions Guide'
                        },
                        {
                            pageId: 'philhealth-contributions',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#philhealth-contributions',
                            title: 'Philhealth Contributions Guide'
                        },
                        {
                            pageId: 'reference-tables',
                            helpLink: 'https://help.sweldonow.ph/guide/payroll.html#reference-tables',
                            title: 'Reference Tables Guide'
                        },
                    ]
                },
                {
                    appId: 'finance',
                    pages: [
                        {
                            pageId: 'loan-self-service',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#self-service-loan-payments-filing',
                            title: 'Self-Service Loan Payments Filing User Guide'
                        },
                        {
                            pageId: 'loan-payments-other-employee',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#filing-for-loan-payments-on-behalf-of-another-employee',
                            title: 'Filing for Loan Payments On Behalf Of Another Employee User Guide'
                        },
                        {
                            pageId: 'loan-review',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#reviewing-loan-payments',
                            title: 'Reviewing Loan Payments User Guide'
                        },
                        {
                            pageId: 'cash-advances-other-employee',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#filing-cash-advances-on-behalf-of-another-employee',
                            title: 'Filing Cash Advances On Behalf Of Another Employee User Guide'
                        },
                        {
                            pageId: 'cash-advances-review',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#reviewing-cash-advances',
                            title: 'Reviewing Cash Advances User Guide'
                        },
                        {
                            pageId: 'cash-advances-self-service',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#self-service-cash-advances-filing',
                            title: 'Self-Service Cash Advances Filing User Guide'
                        },
                        {
                            pageId: 'reimbursements-other-employee',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#filing-reimbursements-on-behalf-of-another-employee',
                            title: 'Filing Reimbursements On Behalf of Another Employee User Guide'
                        },
                        {
                            pageId: 'reimbursements-review',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#reviewing-reimbursements',
                            title: 'Reviewing Reimbursements User Guide'
                        },
                        {
                            pageId: 'reimbursements-self-service',
                            helpLink: 'https://help.sweldonow.ph/guide/finance.html#self-service-reimbursement-filing',
                            title: 'Self-Service Reimbursement Filing User Guide'
                        },
                    ]
                },
                {
                    appId: 'company',
                    pages: [
                        {
                            pageId: 'account',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#account',
                            title: 'Account User Guide'
                        },
                        {
                            pageId: 'employees',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#employees',
                            title: 'Employees User Guide'
                        },
                        {
                            pageId: 'employees-add',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#adding-new-employee',
                            title: 'Adding New Employee User Guide'
                        },
                        {
                            pageId: 'user-profile',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#updating-personal-details',
                            title: 'Updating Personal Details User Guide'
                        },
                        {
                            pageId: 'teams',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#teams',
                            title: 'Teams User Guide'
                        },
                        {
                            pageId: 'timesheets',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#timesheets',
                            title: 'Timesheets User Guide'
                        },
                        {
                            pageId: 'attendance',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#company-attendance',
                            title: 'Company Attendance User Guide'
                        },
                        {
                            pageId: 'workshift-plan',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#workshift-plan-for-all-employees',
                            title: 'Company Workshift Plan User Guide'
                        },
                        {
                            pageId: 'upload-attendance',
                            helpLink: 'https://help.sweldonow.ph/guide/attendance-mgt.html#upload-attendance',
                            title: 'Upload Attendance User Guide'
                        },
                        {
                            pageId: 'linked-accounts',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#linked-accounts',
                            title: 'Linked Accounts User Guide'
                        },
                        {
                            pageId: 'linked-account-create',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#creating-a-linked-account',
                            title: 'Creating a Linked Account User Guide'
                        },
                        {
                            pageId: 'linked-account-manage',
                            helpLink: 'https://help.sweldonow.ph/guide/company.html#managing-linked-accounts',
                            title: 'Managing Linked Accounts User Guide'
                        },
                    ]
                },
                {
                    appId: 'settings',
                    pages: [
                        {
                            pageId: 'access-control',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#access-control',
                            title: 'Access Control User Guide'
                        },
                        {
                            pageId: 'leave-types',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#leave-types',
                            title: 'Leave Types User Guide'
                        },
                        {
                            pageId: 'leave-types-create',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#creating-custom-leave-type',
                            title: 'Creating Custom Leave Type User Guide'
                        },
                        {
                            pageId: 'holidays',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#holidays',
                            title: 'Holidays User Guide'
                        },
                        {
                            pageId: 'holidays-review',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#reviewing-holiday',
                            title: 'Reviewing holiday User Guide'
                        },
                        {
                            pageId: 'calendar-periods',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#calendar-periods',
                            title: 'Calendar Periods User Guide'
                        },
                        {
                            pageId: 'calendar-period-create',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#creating-calendar-period',
                            title: 'Creating Calendar Period User Guide'
                        },
                        {
                            pageId: 'calendar-period-review',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#reviewing-calendar-period',
                            title: 'Reviewing Calendar Period User Guide'
                        },
                        {
                            pageId: 'cutoff-tax-table',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#cutoff-and-tax-table',
                            title: 'Cutoff and Tax Table User Guide'
                        },
                        {
                            pageId: 'workday',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#workday-settings',
                            title: 'Workday Settings User Guide'
                        },
                        {
                            pageId: 'workshifts',
                            helpLink: 'https://help.sweldonow.ph/guide/settings.html#workshifts',
                            title: 'Workshifts User Guide'
                        },
                        {
                            pageId: 'face-ai',
                            helpLink: 'https://help.sweldonow.ph/guide/face-ai-setup.html#face-ai-setup',
                            title: 'Face AI Setup User Guide'
                        },
                    ]
                },
                {
                    appId: 'faceai',
                    pages: [
                        {
                            pageId: 'activation-self-service',
                            helpLink: 'https://help.sweldonow.ph/guide/face-ai-setup.html#self-service-face-ai-activation',
                            title: 'Face AI Activation User Guide'
                        },
                    ]
                },
            ]
        }
    },
    props:['appId','pageId','color'],
    methods: {
        showHelp() {
            if (this.helpLink) {
                window.open(this.helpLink)
            }
        }
    },
    computed: {
        title() {
            if (this.selected) {
                return this.selected.title
            }
        },
        helpLink() {
            if (this.selected) {
                return this.selected.helpLink
            }
        },
        selected() {
            const app = this.helpLinks.filter(x => x.appId == this.appId)
            if (app && app.length) {
                return app[0].pages.filter(x => x.pageId == this.pageId)[0]
            }
        }
    },
    created() {}
}
</script>